var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPinYellowSm(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 12,
    viewBox: "0 0 10 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.66976 11.0578L4.94838 11.3316L5.22701 11.0578L8.2827 8.05532C10.0411 6.32752 10.0411 3.5262 8.2827 1.7984C6.52431 0.0706038 3.67339 0.0706009 1.915 1.7984L1.83977 1.87232C0.039827 3.64095 0.0398276 6.50846 1.83977 8.27709L4.66976 11.0578Z",
    fill: "#EAE21D",
    stroke: "white",
    strokeWidth: 0.78125
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.06508 0.889648C4.02486 0.897982 2.98725 1.29209 2.19357 2.07196L2.11833 2.14588C0.472274 3.76331 0.472274 6.38567 2.11833 8.00309L4.94832 10.7838L5.06508 10.6691V0.889648Z",
    fill: "#FFFA8A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.86963 5.07447C2.86963 3.90207 3.82004 2.95166 4.99244 2.95166H5.06761C6.24 2.95166 7.19041 3.90207 7.19041 5.07447V5.07447C7.19041 6.24686 6.24 7.19728 5.06761 7.19728H4.99244C3.82004 7.19728 2.86963 6.24686 2.86963 5.07447V5.07447Z",
    fill: "#435382"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinYellowSm);
export default __webpack_public_path__ + "static/media/pin-yellow-sm.47217416e43e2957f9ccd5000d6e77b7.svg";
export { ForwardRef as ReactComponent };